export default "__VITE_ASSET__B338fSDy__"